export const slider = [
  {
    id: 1,
    image:
      "https://www.aivanet.com/wp-content/uploads/2019/07/Know-About-the-Future-of-Node-JS-Development.jpg",
    title: "Docker and Kubernetes Mastery",
    description:
      "Learn containerization with Docker and orchestration with Kubernetes for scalable deployments.",
    instructor: "William Foster",
    original_price: 2499,
    discounted_price: 649,
    rating: 4.8,
    category: "Node.js",
    students: 8500,
    hours: 20,
  },
  {
    id: 2,
    image:
      "https://3.bp.blogspot.com/-49KZlsvQZhg/W5emZSjzzZI/AAAAAAAAAMQ/T-eQWNCnGaEA3FcCfiiIvesXZm_YW-vrwCLcBGAs/w1200-h630-p-k-no-nu/reactjs-main-Rlogical.jpg",
    title: "Next.js - Server-side React",
    description:
      "Learn Next.js for server-side rendering and building SEO-friendly React apps.",
    instructor: "Michael Turner",
    original_price: 2799,
    discounted_price: 299,
    rating: 4.8,
    category: "React",
    students: 9200,
    hours: 18,
  },
  {
    id: 3,
    image:
      "https://external-preview.redd.it/NdOn4pvJxI2wHIPeCLbAS7eOoeFHocDm-IpGUWb0Nb4.jpg?auto=webp&s=c1fc7ea2562b08e6ebe5515b1a1f005ca18fbfab",
    title: "State Management with NgRx",
    description: "Learn state management with NgRx for Angular applications.",
    instructor: "David Martin",
    original_price: 4199,
    discounted_price: 449,
    rating: 4.8,
    category: "Angular",
    students: 8200,
    hours: 17,
  },
  {
    id: 4,
    image:
      "https://miro.medium.com/v2/resize:fit:1000/1*i6sXrk_guOE_K0UWHBTgLg.png",
    title: "Full-Stack MERN Development",
    description:
      "Become a full-stack developer with the MERN (MongoDB, Express, React, Node) stack.",
    instructor: "Lucy Turner",
    original_price: 3499,
    discounted_price: 329,
    rating: 4.9,
    category: "Node.js",
    students: 8200,
    hours: 26,
  },
  {
    id: 5,
    image: "https://i.ytimg.com/vi/UxTTEIhJ8to/maxresdefault.jpg",
    title: "Angular Internationalization",
    description:
      "Learn how to internationalize Angular applications for global audiences.",
    instructor: "David Martin",
    original_price: 4499,
    discounted_price: 449,
    rating: 4.8,
    category: "Angular",
    students: 9500,
    hours: 16,
  },
  {
    id: 6,
    image: "https://i.ytimg.com/vi/5p8e2ZkbOFU/maxresdefault.jpg",
    title: "HTML5 Multimedia Development",
    description:
      "Explore multimedia elements in HTML5 for interactive web content.",
    instructor: "Sophie Turner",
    original_price: 2299,
    discounted_price: 239,
    rating: 4.7,
    category: "HTML/CSS",
    students: 9500,
    hours: 18,
  },
  {
    id: 7,
    image: "https://i.ytimg.com/vi/zRlEZ7L1xEM/maxresdefault.jpg",
    title: "Angular Material Design",
    description:
      "Create modern and responsive web designs with Angular Material.",
    instructor: "Nina Patel",
    original_price: 1999,
    discounted_price: 349,
    rating: 4.8,
    category: "Angular",
    students: 10000,
    hours: 18,
  },
  {
    id: 8,
    image:
      "https://i.pinimg.com/originals/a5/76/6a/a5766a8964a2fe89cab314da029cff33.jpg",
    title: "ASP.NET Core MVC Development",
    description: "Build web applications with ASP.NET Core MVC and C#.",
    instructor: "Peter Johnson",
    original_price: 2999,
    discounted_price: 249,
    rating: 4.8,
    category: "ASP.NET Core",
    students: 7500,
    hours: 26,
  },
];
